import createStore from "zustand";
import { Course, CourseAI, Lesson } from "./courseStore";
import { SetStateAction } from "react";
import { NextRouter } from "next/router";

export type Assignment = {
  id?: number;
  assignment_question?: string;
  assignment_answers?: string;
};

export type AssignmentStore = {
  // state
  userAnswer: CourseAI | null;
  isAssignmentDone: boolean;
  showAlertAssignment: boolean;
  localAnswers: Record<number, string>;
  isFinished: boolean;
  isRetakeAssignment: boolean;
  assignments: Assignment[];
  currentLesson: Lesson;
  currentCourse: Course;

  // actions
  setUserAnswer: (userAnswer: SetStateAction<CourseAI | null>) => void;
  setIsAssignmentDone: (isAssignmentDone: boolean) => void;
  setShowAlertAssignment: (
    showAlertAssignment: SetStateAction<boolean>
  ) => void;
  setLocalAnswers: (
    localAnswers: SetStateAction<Record<number, string>>
  ) => void;
  setIsFinished: (isFinished: SetStateAction<boolean>) => void;
  setIsRetakeAssignment: (isRetakeAssignment: SetStateAction<boolean>) => void;
  onCloseAlertAssignment: (router: NextRouter) => void;
  onCloseModal: (router: NextRouter) => void;
  onResumeAssignment: () => void;
  setAssignments: (assignments: Assignment[]) => void;
  setCurrentLesson: (item: Lesson) => void;
  setCurrentCourse: (item: Course) => void;
};

export const useAssignmentStore = createStore<AssignmentStore>((set, get) => ({
  // state
  userAnswer: null,
  isAssignmentDone: false,
  showAlertAssignment: false,
  localAnswers: {},
  isFinished: false,
  isRetakeAssignment: false,
  assignments: [],
  currentLesson: {},
  currentCourse: {},

  // actions
  setUserAnswer(userAnswer) {
    set((state) => ({
      userAnswer:
        typeof userAnswer === "function"
          ? userAnswer(state.userAnswer)
          : userAnswer,
    }));
  },
  setIsAssignmentDone(item) {
    set({
      isAssignmentDone: item,
    });
  },
  setShowAlertAssignment(showAlertAssignment) {
    set((state) => ({
      showAlertAssignment:
        typeof showAlertAssignment === "function"
          ? showAlertAssignment(state.showAlertAssignment)
          : showAlertAssignment,
    }));
  },
  setLocalAnswers(localAnswers) {
    set((state) => ({
      localAnswers:
        typeof localAnswers === "function"
          ? localAnswers(state.localAnswers)
          : localAnswers,
    }));
  },
  setIsFinished(isFinished) {
    set((state) => ({
      isFinished:
        typeof isFinished === "function"
          ? isFinished(state.isFinished)
          : isFinished,
    }));
  },
  setIsRetakeAssignment(isRetakeAssignment) {
    set((state) => ({
      isRetakeAssignment:
        typeof isRetakeAssignment === "function"
          ? isRetakeAssignment(state.isRetakeAssignment)
          : isRetakeAssignment,
    }));
  },
  onCloseModal(router) {
    const {
      setIsFinished,
      setIsRetakeAssignment,
      localAnswers,
      setLocalAnswers,
      setShowAlertAssignment,
      assignments,
      currentCourse,
      currentLesson,
    } = get();

    if (
      localAnswers[assignments[0]?.id] == "" ||
      Object.keys(localAnswers).length === 0
    ) {
      setIsFinished(false);
      setIsRetakeAssignment(false);
      setLocalAnswers({});
      // TODO: onClose();
      router.push({
        pathname: "/course/[courseSlug]",
        query: {
          courseSlug: currentCourse?.slug,
          lesson: currentLesson?.slug,
        },
      });
    } else {
      setShowAlertAssignment(true);
    }
  },
  onCloseAlertAssignment(router) {
    const {
      setIsFinished,
      setIsRetakeAssignment,
      setLocalAnswers,
      currentCourse,
      currentLesson,
    } = get();

    setIsFinished(false);
    setIsRetakeAssignment(false);
    setLocalAnswers({});
    // TODO: onClose();
    router.push({
      pathname: "/course/[courseSlug]",
      query: {
        courseSlug: currentCourse?.slug,
        lesson: currentLesson?.slug,
      },
    });
  },
  onResumeAssignment() {
    const { setShowAlertAssignment } = get();
    setShowAlertAssignment(false);
  },
  setAssignments(item) {
    set({
      assignments: item,
    });
  },
  setCurrentLesson(item) {
    set({ currentLesson: item });
  },
  setCurrentCourse(item) {
    set({ currentCourse: item });
  },
}));
